export var OrgOnboardingStep;
(function (OrgOnboardingStep) {
    OrgOnboardingStep["WorkspaceCreated"] = "workspace_created";
    OrgOnboardingStep["PreferencesSet"] = "preferences_set";
    OrgOnboardingStep["TeammatesInvited"] = "teammates_invited";
    OrgOnboardingStep["TeammatesSkipped"] = "teammates_skipped";
    OrgOnboardingStep["Completed"] = "completed";
})(OrgOnboardingStep || (OrgOnboardingStep = {}));
// State-only (no org yet) can be represented by the route logic; if needed:
export const PreOrgOnboardingState = {
    WelcomeConsented: "welcome_consented",
};
